import { useState, useEffect, useMemo } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation, Outlet, useSearchParams } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";


import MDBox from "components/MDBox";

import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

import themeRTL from "assets/theme/theme-rtl";

import themeDarkRTL from "assets/theme-dark/theme-rtl";

// RTL plugins
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

import routes from "routes";

import { useMaterialUIController, setOpenConfigurator } from "context";

// Images
import brandWhite from "assets/images/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";
import SignIn from "layouts/authentication/sign-in";
import ReservedList from "layouts/dashboard/ReservedList";
import { getMe } from "./api/routes";
import Update from "./layouts/reservedList/Update";
import ReservationPrintPreview from "./layouts/reservedList/ReservationPrintPreview";
import ReservationNoteBookList from "./layouts/reservationNotebook/ReservationNoteBookList";
import FillTimeList from "./layouts/fillTime/FillTimeList";
import { toast } from "react-toastify";
import Loading from "./components/Loading";
import NoteBookFullView from "./layouts/reservationNotebook/NoteBookFullView";

export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const [searchParams] = useSearchParams();
  const {
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();
  const [me, setMe] = useState({});
  const [loading, setLoading] = useState(false);

  // Cache for the rtl
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);
  useEffect(() => {
    if (sessionStorage.getItem("x-auth-token")) {
      setLoading(true);
      getMe((isOk, data) => {
        if (!isOk) {
          setLoading(false);
          return toast.error(data.message);
        } else {
          setLoading(false);
          sessionStorage.setItem("fullname", data[0]?.fullname);
          return setMe(data[0]);
        }
      });
    }

  }, [sessionStorage.getItem("x-auth-token")]);
  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    // if (miniSidenav && !onMouseEnter) {
    //     setMiniSidenav(dispatch, false);
    //     setOnMouseEnter(true);
    // }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    // if (onMouseEnter) {
    //     setMiniSidenav(dispatch, true);
    //     setOnMouseEnter(false);
    // }
  };

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse && route.role.includes(me?.role)) {
        return getRoutes(route.collapse);
      }

      if (route.route && route.role.includes(me?.role)) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  const privateRouteHandler = (allRoutes) => {
    return allRoutes.map((route) => {
      if (route.role.includes(me?.role)) {
        return route;
      } else return {};
    });
  };

  return direction === "rtl" && (
    <CacheProvider value={rtlCache}>
      <Loading loading={loading} />
      <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
        <CssBaseline />
        {layout === "dashboard" && searchParams.get("hideSideNav") === null && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
              brandName="پنل مدیریت"
              routes={privateRouteHandler(routes)}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          <Route path="/login" element={<SignIn />} />
          <Route path={"/"} element={<PrivateAfterLogin />}>
            {getRoutes(routes)}
            <Route path="/reservedList" element={<ReservedList />} />
            <Route path="/reservationNotebook/viewNotebook" element={<ReservationNoteBookList />} />
            <Route path="/noteBookFullView" element={<NoteBookFullView />} />
            <Route path="/fill-time/viewFillTime" element={<FillTimeList />} />
            <Route path="/update-info" element={<Update />} />
            <Route path="/reservationList/print-preview" element={<ReservationPrintPreview />} />
          </Route>
        </Routes>
      </ThemeProvider>
    </CacheProvider>
  );
}
const isLogin = () => !!sessionStorage.getItem("x-auth-token");
const PrivateAfterLogin = () => {
  return isLogin() ? <Outlet /> : <Navigate to={"/login"} />;
};
